import React from "react";
import CommonModal from "../../../components/Common/CommonModal";
import CommonButton from "../../../components/buttons/CommonButton";
import CommonSelect from "../../../components/forms/CommonSelect";
import {
  handleChange,
  handleChangeFile,
  handleChangeNameValue,
  handleChangeNumeral,
} from "../../../helpers/handleFormChanges";
import CommonInput from "../../../components/forms/CommonInput";
import CommonInputValor from "../../../components/forms/CommonInputValor";
import CommonInputDate from "../../../components/forms/CommonInputDate";
import CommonInputFile from "../../../components/forms/CommonInputFile";
import Validation from "../../../helpers/Validation";
import ErrorSwal from "../../../components/Swal/errorSwal";
import Format from "../../../helpers/Format";
import PropTypes from "prop-types";
import useTipos from "../../../hooks/common/useTipos";

function UploadModal({ modalHook, valuesHook, uploadNotaFiscal, clientes }) {
  const { uploadModal, setUploadModal } = modalHook;
  const { values, setValues } = valuesHook;
  const tiposNotaFiscal = useTipos("tipos_nota_fiscal");

  return (
    <CommonModal
      title="Upload de notas fiscais"
      is_open_modal={uploadModal}
      set_is_open_modal={setUploadModal}
      size="xl"
      buttons={
        <CommonButton
          color="success"
          onClick={() => {
            uploadNotaFiscal();
          }}
        >
          Upload
        </CommonButton>
      }
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          uploadNotaFiscal();
        }}
      >
        <div className="row">
          <div className="col-md-3 mb-3">
            <CommonSelect
              label="Tipo de nota"
              id="tipo_nota"
              value={values.tipo_nota}
              onChange={(e) => {
                handleChange(e, values, setValues);
              }}
              data={tiposNotaFiscal.map((tipoNota) => ({
                text: tipoNota.valor,
                id: tipoNota.chave,
              }))}
              placeholder="Selecione o tipo"
              required
            />
          </div>
          <div className="col-md-3 mb-3">
            <CommonInput
              label="Número da nota"
              id="numero_nota"
              value={values.numero_nota}
              onChange={(e) => {
                handleChangeNumeral(e, values, setValues);
              }}
              placeholder="Digite um número"
              required
            />
          </div>
          <div className="col-md-3 mb-3">
            <CommonInputValor
              label="Valor"
              id="valor_nota"
              value={values.valor_nota}
              onChange={(e) => {
                handleChangeNameValue(
                  "valor_nota",
                  e.target.value,
                  values,
                  setValues
                );
              }}
              required
            />
          </div>
          <div className="col-md-3 mb-3">
            <CommonInputDate
              label="Data de emissão"
              id="data_emissao"
              value={values.data_emissao}
              onChange={(e) => {
                handleChange(e, values, setValues);
              }}
              required
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-3 mb-3">
            <CommonSelect
              label="Tipo de mercado"
              id="tipo_mercado"
              value={values.tipo_mercado}
              onChange={(e) => {
                handleChange(e, values, setValues);
              }}
              data={[
                { id: 1, text: "Interno" },
                { id: 2, text: "Externo" },
              ]}
              placeholder="Selecione o tipo"
              required
            />
          </div>
          <div className="col-md-5 mb-3">
            <CommonInputFile
              label="Selecione o arquivo"
              id="arquivo"
              accept=".pdf"
              onChange={(e) => {
                if (
                  e.target.files[0] &&
                  Validation.verificarTipoArquivo(
                    ["pdf"],
                    e.target.files[0].name
                  )
                )
                  return ErrorSwal({
                    title: "Formato de arquivo inválido.",
                  }).then(() => {
                    e.target.value = "";
                  });
                handleChangeFile(e, values, setValues);
              }}
              required
            />
          </div>
          <div className="col-md-4 mb-3">
            <CommonSelect
              label="Tomador"
              id="tomador"
              value={values.tomador}
              onChange={(e) => {
                const selectedOption = e.target.options[e.target.selectedIndex];
                const selectedNome = selectedOption
                  ? selectedOption?.dataset?.nome
                  : null;

                setValues({
                  ...values,
                  [e.target.name]: e.target.value,
                  nome: selectedNome,
                });
              }}
              data={[
                {
                  text: "Clientes diversos",
                  "data-nome": "Clientes diversos",
                },
                ...clientes.map((cliente) => ({
                  text: `${cliente.razao_social} (${
                    cliente.cnpj === "99999999999"
                      ? "Estrangeiro"
                      : cliente.cnpj.length === 14
                        ? Format.formataCNPJ(cliente.cnpj)
                        : Format.formataCPF(cliente.cnpj)
                  })`,
                  id: cliente.uid,
                  "data-nome": cliente.razao_social,
                })),
              ]}
              placeholder="Selecione o tomador"
              required
            />
          </div>
        </div>
      </form>
    </CommonModal>
  );
}

UploadModal.propTypes = {
  modalHook: PropTypes.shape({
    uploadModal: PropTypes.bool.isRequired,
    setUploadModal: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  uploadNotaFiscal: PropTypes.func.isRequired,
  clientes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default UploadModal;
